(function() {
  'use strict';
  
  // Set year
  const yearEl = document.getElementById("trackfitYear");
  if(yearEl) yearEl.textContent = new Date().getFullYear();

  // Speed data
  const speedData = [
    {step:1, mph:4.1, d:null},
    {step:2, mph:7.2, d:+3.1},
    {step:3, mph:10.9, d:+3.7},
    {step:4, mph:13.4, d:+2.5},
    {step:5, mph:15.2, d:+1.8},
    {step:6, mph:16.8, d:+1.6},
    {step:7, mph:18.0, d:+1.2},
    {step:8, mph:19.1, d:+1.1},
    {step:9, mph:20.0, d:+0.9},
    {step:10, mph:20.6, d:+0.6},
    {step:11, mph:21.1, d:+0.5},
    {step:12, mph:21.3, d:+0.2},
    {step:13, mph:21.5, d:+0.2},
    {step:14, mph:21.6, d:+0.1},
    {step:15, mph:21.5, d:-0.1},
    {step:16, mph:21.3, d:-0.2},
    {step:17, mph:21.2, d:-0.1},
    {step:18, mph:21.0, d:-0.2},
    {step:19, mph:20.7, d:-0.3},
    {step:20, mph:20.2, d:-0.5},
    {step:21, mph:19.5, d:-0.7},
    {step:22, mph:18.6, d:-0.9},
  ];

  // Force bands
  const forceBands = [
    {range:"1–5", stepTime:"~0.22", trend:"Rapid increase", effort:[120,220], impact:[480,700]},
    {range:"6–10", stepTime:"~0.21", trend:"Moderate increase", effort:[90,180], impact:[450,660]},
    {range:"11–14", stepTime:"~0.20", trend:"Flat", effort:[70,150], impact:[400,600]},
    {range:"15–22", stepTime:"0.21–0.23", trend:"Declining", effort:[40,120], impact:[450,720]}
  ];

  // Helper functions
  const mid = (p) => (p[0] + p[1]) / 2;
  const fmt = (p) => `${p[0]}–${p[1]} lb`;

  // Speed rows (first 12)
  const speedRowsEl = document.getElementById("trackfitSpeedRows");
  if(speedRowsEl){
    const first = speedData.slice(0,12);
    speedRowsEl.innerHTML = first.map(r => {
      const d = (r.d === null) ? "—" : (r.d > 0 ? `+${r.d.toFixed(1)}` : r.d.toFixed(1));
      return `
        <div class="trackfit-r" style="grid-template-columns: .7fr .8fr 1.5fr;">
          <div class="trackfit-c0">Step ${r.step}</div>
          <div class="trackfit-c1"><b>${r.mph.toFixed(1)}</b> mph</div>
          <div class="trackfit-c2">Δ prior <b>${d}</b> mph</div>
        </div>
      `;
    }).join("");
  }

  // Force rows
  const forceRowsEl = document.getElementById("trackfitForceRows");
  if(forceRowsEl){
    forceRowsEl.innerHTML = forceBands.map(r => {
      const eMid = mid(r.effort);
      const iMid = mid(r.impact);
      const effPct = Math.round((eMid / iMid) * 100);
      return `
        <div class="trackfit-r" style="grid-template-columns: .9fr 1.4fr .7fr;">
          <div class="trackfit-c0">${r.range}</div>
          <div class="trackfit-c1">
            <b>${r.stepTime}</b> • ${r.trend}
            <div style="margin-top:6px;color:rgba(184,192,217,.78);font-size:12px;">
              Effort: <b style="color:rgba(243,246,255,.92)">${fmt(r.effort)}</b> • Impact: <b style="color:rgba(243,246,255,.92)">${fmt(r.impact)}</b>
            </div>
          </div>
          <div class="trackfit-c2">Effort% <b>${effPct}%</b></div>
        </div>
      `;
    }).join("");
  }

  // Force bars
  const maxImpact = forceBands.reduce((m, r) => Math.max(m, mid(r.impact)), 0);
  const forceBarsEl = document.getElementById("trackfitForceBars");
  if(forceBarsEl){
    forceBarsEl.innerHTML = forceBands.map(r => {
      const eMid = mid(r.effort);
      const iMid = mid(r.impact);
      const effPct = Math.round((eMid / iMid) * 100);
      const w = Math.max(8, Math.min(100, (mid(r.impact) / maxImpact) * 100));
      return `
        <div class="trackfit-bar-row">
          <div style="font-weight:950; font-size:12.5px; color:rgba(243,246,255,.95);">${r.range}</div>
          <div class="trackfit-track">
            <div class="trackfit-fill" style="width:${Math.min(100, (effPct / 100) * w)}%"></div>
          </div>
          <div class="trackfit-pct">${effPct}%</div>
        </div>
      `;
    }).join("");
  }

  // Motion DNA rows
  const mdnaEl = document.getElementById("trackfitMdnaRows");
  if(mdnaEl){
    const mdnaRows = [
      {k:"Transfer efficiency", g:58, meaning:"How much load becomes forward speed", pri:"High"},
      {k:"Posture / hip control", g:74, meaning:"Stay tall at speed", pri:"Medium"},
      {k:"Foot contact stability", g:61, meaning:"Contact quality under speed", pri:"High"},
      {k:"Stiffness timing", g:63, meaning:"Avoid late braking at speed", pri:"High"},
      {k:"Consistency", g:70, meaning:"Repeatable contacts rep-to-rep", pri:"Medium"},
    ];
    mdnaEl.innerHTML = mdnaRows.map(r => {
      return `
        <div class="trackfit-r" style="grid-template-columns: 1.25fr .55fr 1.2fr;">
          <div class="trackfit-c0">${r.k}</div>
          <div class="trackfit-c1"><b>${r.g}</b></div>
          <div class="trackfit-c2">${r.meaning} • <b>${r.pri}</b></div>
        </div>
      `;
    }).join("");
  }

  // Speed chart builder
  function buildSpeedChart(el, data, opts){
    if(!el) return;
    
    const W = 1000, H = 360;
    const padL = 52, padR = 18, padT = 18, padB = 42;

    const steps = data.map(d => d.step);
    const vals = data.map(d => d.mph);

    const xMin = Math.min(...steps);
    const xMax = Math.max(...steps);
    const yMin = Math.floor((Math.min(...vals) - 1) / 2) * 2;
    const yMax = Math.ceil((Math.max(...vals) + 1) / 2) * 2;

    const x = s => padL + ((s - xMin) / (xMax - xMin)) * (W - padL - padR);
    const y = v => padT + (1 - ((v - yMin) / (yMax - yMin))) * (H - padT - padB);

    let dPath = "";
    data.forEach((pt, i) => {
      dPath += (i === 0 ? "M " : " L ") + x(pt.step).toFixed(1) + " " + y(pt.mph).toFixed(1);
    });

    const leakStep = 15;
    const peak = data.reduce((a, b) => (b.mph > a.mph ? b : a), data[0]);
    const leakX = x(leakStep);

    // Grid lines
    const gridN = 5;
    let grid = "";
    for(let i = 0; i <= gridN; i++){
      const yy = padT + (i / gridN) * (H - padT - padB);
      grid += `<line class="trackfit-grid-line" x1="${padL}" y1="${yy}" x2="${W - padR}" y2="${yy}"></line>`;
    }

    // X axis labels
    const xTicks = opts && opts.compact ? [1, 8, 15, 22] : [1, 6, 11, 16, 21];
    let xText = xTicks.map(t => `<text class="trackfit-axis-text" x="${x(t)}" y="${H - 18}" text-anchor="middle">${t}</text>`).join("");

    // Y axis labels
    const yTicks = [yMin, Math.round((yMin + yMax) / 2), yMax];
    let yText = yTicks.map(v => `<text class="trackfit-axis-text" x="10" y="${y(v) + 4}">${v}</text>`).join("");

    const svg = `
      <svg viewBox="0 0 ${W} ${H}" role="img" aria-label="Speed curve">
        ${grid}
        <line class="trackfit-grid-line" x1="${padL}" y1="${padT}" x2="${padL}" y2="${H - padB}"></line>
        <line class="trackfit-grid-line" x1="${padL}" y1="${H - padB}" x2="${W - padR}" y2="${H - padB}"></line>
        <line class="trackfit-mark-line" x1="${leakX}" y1="${padT}" x2="${leakX}" y2="${H - padB}"></line>
        <text class="trackfit-mark-text" x="${Math.min(W - 150, leakX + 8)}" y="${padT + 12}">Leak ~ step ${leakStep}</text>
        <path class="trackfit-line-main" d="${dPath}"></path>
        <circle class="trackfit-pt" cx="${x(peak.step)}" cy="${y(peak.mph)}" r="4.6"></circle>
        ${yText}
        ${xText}
        <text class="trackfit-axis-text" x="${W - 10}" y="${H - 18}" text-anchor="end">Step</text>
        <text class="trackfit-axis-text" x="10" y="${padT + 10}">mph</text>
      </svg>
    `;
    el.innerHTML = svg;
  }

  // Build charts
  const miniChart = document.getElementById("trackfitChartMini");
  const fullChart = document.getElementById("trackfitChartFull");
  if(miniChart) buildSpeedChart(miniChart, speedData, {compact: true});
  if(fullChart) buildSpeedChart(fullChart, speedData, {compact: false});

  // Pager logic
  const pages = Array.from(document.querySelectorAll(".trackfit-page"));
  const subtitle = document.getElementById("trackfitSubtitle");
  const dotsWrap = document.getElementById("trackfitDots");
  const prevBtn = document.getElementById("trackfitPrev");
  const nextBtn = document.getElementById("trackfitNext");

  if(!pages.length) return;

  let idx = 0;

  function renderDots(){
    if(!dotsWrap) return;
    dotsWrap.innerHTML = pages.map((_, i) => 
      `<div class="trackfit-d ${i === idx ? "trackfit-d-on" : ""}" data-i="${i}"></div>`
    ).join("");
    dotsWrap.querySelectorAll(".trackfit-d").forEach(d => {
      d.addEventListener("click", () => go(+d.getAttribute("data-i")));
    });
  }

  function go(n){
    idx = (n + pages.length) % pages.length;
    pages.forEach((p, i) => p.classList.toggle("trackfit-page-on", i === idx));
    if(subtitle) subtitle.textContent = pages[idx].getAttribute("data-title") || "";
    renderDots();
  }

  if(prevBtn) prevBtn.addEventListener("click", () => go(idx - 1));
  if(nextBtn) nextBtn.addEventListener("click", () => go(idx + 1));

  // Keyboard navigation
  window.addEventListener("keydown", (e) => {
    if(e.key === "ArrowLeft") go(idx - 1);
    if(e.key === "ArrowRight") go(idx + 1);
  });

  // Touch/swipe navigation
  let x0 = null, y0 = null;
  const swipeEl = document.querySelector(".trackfit-main");
  if(swipeEl){
    swipeEl.addEventListener("touchstart", (e) => {
      const t = e.touches[0];
      x0 = t.clientX;
      y0 = t.clientY;
    }, {passive: true});

    swipeEl.addEventListener("touchend", (e) => {
      if(x0 === null) return;
      const t = e.changedTouches[0];
      const dx = t.clientX - x0;
      const dy = t.clientY - y0;
      x0 = null;
      y0 = null;
      if(Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 40){
        if(dx < 0) go(idx + 1);
        else go(idx - 1);
      }
    }, {passive: true});
  }

  // Initialize
  renderDots();
  go(0);
})();